// @flow strict
import type {
  ReferralSetting,
  ReferralSettingApiRequest,
} from 'src/types/referral-v2';
import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {useSelector, useDispatch} from 'react-redux';
//$FlowFixMe[nonstrict-import]
import usePrivilege from 'src/hooks/usePrivilege';
// $FlowFixMe[nonstrict-import]
import {AnalyticsService} from 'src/analytics';
// $FlowFixMe[nonstrict-import]
import {getTimeSheetSyncOptions} from 'src/utils/referral-v2.js';
import {updateReferralSettings} from 'src/action-creators/referral-v2/referral-settings.js';
import {selectReferralSetting} from 'src/selectors/referral-settings.js';
import {SubTitleSmall} from '@spaced-out/ui-design-system/lib/components/Text';
import {
  Card,
  CardHeader,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import {AutoSubmitRequestConfig} from 'src/components/referrer-portal/settings/notification/notification.jsx';
import {SingleSelectDropdown} from 'src/components/referral-job-list/settings/one-time-settings.jsx';
import css from 'src/components/referral-v2/configure/configure.css';


const OtherSettings = (): React.Node => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const timeSheetSyncOptions = getTimeSheetSyncOptions(t);
  const dispatch = useDispatch();
  const referralSettings: ?ReferralSetting = useSelector(selectReferralSetting);

  const hasSuperAdminAccess = usePrivilege('ADMIN_REFERRALS_V2');

  const onOtherSettingChange = (fieldName: string, value: boolean | string) => {
    const payload: ReferralSettingApiRequest[] = [
      {category: 'other_settings', configs: [{key: fieldName, value}]},
    ];
    AnalyticsService.track('Referral review', {referralReview: value});
    dispatch(updateReferralSettings(payload));
  };
  return (
    <div className={css.generalNotificationsContent}>
      <AutoSubmitRequestConfig className={css.defaultMargin} />
      {hasSuperAdminAccess && (
        <Card type="primary">
          <CardHeader className={css.stepperCardHeader}>
            <SubTitleSmall>
              {t('Other_Settings', 'Other Settings')}
            </SubTitleSmall>
          </CardHeader>
          <CardContent className={css.contentSection}>
            <div className={css.defaultMargin}>
              <SingleSelectDropdown
                value={referralSettings?.other_settings.review_profile.toLocaleString()}
                onChangeOption={(value) => {
                  const valueChanged = value === 'true' ? true : false;
                  onOtherSettingChange('review_profile', valueChanged);
                }}
                label={`${t(
                  'Do_you_want_your_recruiters_to_review_the_referrals_before_they_are_submitted_into_your_ATS',
                  'Do you want your recruiters to review the referrals before they are submitted into your ATS',
                )}?`}
              />
            </div>
            <div className={css.defaultMargin}>
              <SingleSelectDropdown
                value={
                  referralSettings?.other_settings.timesheet_sync_type
                    ? referralSettings.other_settings.timesheet_sync_type.toLocaleString()
                    : 'overwrite'
                }
                onChangeOption={(value) => {
                  onOtherSettingChange('timesheet_sync_type', value);
                }}
                options={timeSheetSyncOptions}
                label={t('Timesheet_Sync_Type', 'Timesheet Sync Type')}
              />
            </div>
            <SingleSelectDropdown
              value={referralSettings?.other_settings.resume_option_for_personalised_form.toLocaleString()}
              onChangeOption={(value) => {
                const valueChanged = value === 'true' ? true : false;
                onOtherSettingChange(
                  'resume_option_for_personalised_form',
                  valueChanged,
                );
              }}
              label={`${t(
                'Do_you_want_to_make_resume_field_optional_for_personalised_form',
                'Do you want to make resume field optional for personalised form',
              )}?`}
            />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default OtherSettings;
